module.exports = __webpack_public_path__ + "static/Arimo-Regular-9fe23bf225eecfcdb736e063b08a6123.ttf";